module.exports = __webpack_public_path__ + "img/ai.4736ff1a.png";